import { ILocalizable } from "infrastructure/localization";

import { IValidatable, IValidationRule, IValidationIssue, ValidationIssueSeverity, ValidationTag } from "./validation.types";

export const createValidatable: <T>(value: T, rules: Array<IValidationRule<T>>, onCreated?: (validatable: IValidatable<T>) => void) => IValidatable<T> = <T>(
  value: T,
  rules: Array<IValidationRule<T>>,
  onCreated?: (validatable: IValidatable<T>) => void
) => {
  const result: IValidatable<T> = {
    value: value,
    validation: {
      rules: rules
    }
  };

  onCreated?.(result);

  return result;
};

export const createValidationIssue: (message: ILocalizable | string | undefined, severity?: ValidationIssueSeverity, tag?: ValidationTag) => IValidationIssue = (
  message,
  severity = ValidationIssueSeverity.Error,
  tag
) => {
  return {
    message: message,
    severity: severity,
    tag: tag
  };
};

export const validate: (values: { [x: string]: IValidatable<any> }) => { [x: string]: ILocalizable | string | undefined } | undefined = values => {
  let result: { [x: string]: ILocalizable | string | undefined } | undefined;

  Object.keys(values).forEach(key => {
    const field: IValidatable<any> = values[key];

    const brokenRule = field.validation.rules.filter(
      (r: IValidationRule<any>) =>
        !r.valid(
          field.value,
          field.validation.dependsOnFieldNames?.map(e => values[e].value)
        )
    )[0];

    values[key] = {
      ...field,
      validation: {
        ...field.validation,
        result: brokenRule?.result
      }
    };

    if (brokenRule && !result) {
      result = {
        [key]: brokenRule.result?.message
      };
    }
  });

  return result;
};
